import React from 'react';
import Image from 'next/image';

export default function Footer() {
  return (
    <footer style={{ background: '#1A1714', borderTop: '1px solid rgba(196,180,154,0.2)' }}>
      {/* Decorative top accent */}
      <div style={{ height: '1px', background: 'linear-gradient(to right, transparent, rgba(196,180,154,0.5), transparent)' }} />
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <Image
                src="/assets/images/LOGOGESTRA-1774946360062.png"
                alt="Gestra Antiokupa logo"
                width={40}
                height={40}
                className="object-contain"
              />
              <span
                className="font-semibold text-sm tracking-widest uppercase"
                style={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.18em', color: '#D8CCBB' }}
              >
                Gestra Antiokupa
              </span>
            </div>
            <p style={{ color: 'rgba(247,243,236,0.35)', fontSize: '12px', lineHeight: 1.8, maxWidth: '260px', fontFamily: 'Montserrat, sans-serif' }}>
              Especialistas en recuperación de inmuebles ocupados y protección de la propiedad privada.
            </p>
            {/* Social Icons */}
            <div className="flex items-center gap-3 mt-2">
              {[
                {
                  href: 'https://www.instagram.com/gestra_antiokupa',
                  label: 'Instagram',
                  icon: (
                    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  ),
                },
                {
                  href: 'https://www.facebook.com/gestraantiokupa',
                  label: 'Facebook',
                  icon: (
                    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                  ),
                },
                {
                  href: 'https://wa.me/34634941415',
                  label: 'WhatsApp',
                  icon: (
                    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                  ),
                },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={item.label}
                  className="w-9 h-9 flex items-center justify-center transition-all duration-200"
                  style={{ border: '1px solid rgba(196,180,154,0.2)', color: 'rgba(196,180,154,0.5)' }}
                  onMouseEnter={e => {
                    (e.currentTarget as HTMLElement).style.borderColor = '#C4B49A';
                    (e.currentTarget as HTMLElement).style.color = '#C4B49A';
                  }}
                  onMouseLeave={e => {
                    (e.currentTarget as HTMLElement).style.borderColor = 'rgba(196,180,154,0.2)';
                    (e.currentTarget as HTMLElement).style.color = 'rgba(196,180,154,0.5)';
                  }}
                >
                  {item.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div className="flex flex-col gap-4">
            <h4
              className="text-xs font-bold tracking-widest uppercase mb-2"
              style={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.25em', color: '#C4B49A' }}
            >
              Servicios
            </h4>
            {[
              'Recuperación de Inmuebles',
              'Mediación con Ocupantes',
              'Protección de Propiedades',
              'Vigilancia y Cámaras',
              'Asesoría Jurídica',
            ]?.map((item) => (
              <a
                key={item}
                href="#servicios"
                className="text-sm transition-colors duration-200"
                style={{ color: 'rgba(247,243,236,0.35)', fontFamily: 'Montserrat, sans-serif', fontSize: '12px' }}
                onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = 'rgba(247,243,236,0.7)')}
                onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = 'rgba(247,243,236,0.35)')}
              >
                {item}
              </a>
            ))}
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-4">
            <h4
              className="text-xs font-bold tracking-widest uppercase mb-2"
              style={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.25em', color: '#C4B49A' }}
            >
              Contacto
            </h4>
            <div style={{ color: 'rgba(247,243,236,0.35)', fontFamily: 'Montserrat, sans-serif', fontSize: '12px', lineHeight: 1.7 }}>
              Carrer Aragó, 24 Llevant<br />
              07006 Palma, Illes Balears
            </div>
            <a
              href="tel:+34634941415"
              className="transition-colors duration-200"
              style={{ color: 'rgba(247,243,236,0.35)', fontFamily: 'Montserrat, sans-serif', fontSize: '12px' }}
              onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = 'rgba(247,243,236,0.7)')}
              onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = 'rgba(247,243,236,0.35)')}
            >
              634 94 14 15
            </a>
            <a
              href="tel:+34971079369"
              className="transition-colors duration-200"
              style={{ color: 'rgba(247,243,236,0.35)', fontFamily: 'Montserrat, sans-serif', fontSize: '12px' }}
              onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = 'rgba(247,243,236,0.7)')}
              onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = 'rgba(247,243,236,0.35)')}
            >
              Fijo: 971 079 369
            </a>
            <a
              href="mailto:Info@gestraantiokupa.com"
              className="transition-colors duration-200"
              style={{ color: 'rgba(247,243,236,0.35)', fontFamily: 'Montserrat, sans-serif', fontSize: '12px' }}
              onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = 'rgba(247,243,236,0.7)')}
              onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = 'rgba(247,243,236,0.35)')}
            >
              Info@gestraantiokupa.com
            </a>
            <div style={{ color: 'rgba(247,243,236,0.25)', fontFamily: 'Montserrat, sans-serif', fontSize: '11px', lineHeight: 1.7 }}>
              Lun – Vie: 9:30–13:30 · 16:00–18:30<br />
              Sáb y Dom: Cerrado
            </div>
            <a
              href="#contacto"
              className="mt-2 inline-flex items-center justify-center px-6 py-3 text-xs font-bold tracking-widest uppercase transition-all duration-200"
              style={{ background: '#C4B49A', color: '#1A1714', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.15em' }}
            >
              Solicitar Evaluación
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4" style={{ borderTop: '1px solid rgba(196,180,154,0.12)' }}>
          <p style={{ color: 'rgba(247,243,236,0.2)', fontSize: '11px', fontFamily: 'Montserrat, sans-serif' }}>
            © 2026 Gestra Antiokupa. Todos los derechos reservados.
          </p>
          <p style={{ color: 'rgba(196,180,154,0.4)', fontSize: '11px', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.08em' }}>
            Protección de la propiedad privada · Actuación discreta y eficaz
          </p>
        </div>
      </div>
    </footer>
  );
}